import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_15907473 from 'nuxt_plugin_bootstrapvue_15907473' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_gtm_36e2bbcc from 'nuxt_plugin_gtm_36e2bbcc' // Source: ./gtm.js (mode: 'client')
import nuxt_plugin_bugsnagclientbedf0236_e38eaa74 from 'nuxt_plugin_bugsnagclientbedf0236_e38eaa74' // Source: ./bugsnag.client.bedf0236.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_11ae9c28 from 'nuxt_plugin_cookieuniversalnuxt_11ae9c28' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_libmoduleplugin718bb2ca_ff181700 from 'nuxt_plugin_libmoduleplugin718bb2ca_ff181700' // Source: ./lib.module.plugin.718bb2ca.js (mode: 'all')
import nuxt_plugin_axios_5c841a44 from 'nuxt_plugin_axios_5c841a44' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_router_2f688c2a from 'nuxt_plugin_router_2f688c2a' // Source: ./router.js (mode: 'all')
import nuxt_plugin_polyfills_7dce8c4e from 'nuxt_plugin_polyfills_7dce8c4e' // Source: ../plugins/polyfills (mode: 'client')
import nuxt_plugin_utils_3336a20a from 'nuxt_plugin_utils_3336a20a' // Source: ../plugins/utils (mode: 'all')
import nuxt_plugin_clientUtils_9395db20 from 'nuxt_plugin_clientUtils_9395db20' // Source: ../plugins/clientUtils (mode: 'client')
import nuxt_plugin_events_6a03e7e2 from 'nuxt_plugin_events_6a03e7e2' // Source: ../plugins/events (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_cookieinformation_a7dd78dc from 'nuxt_plugin_cookieinformation_a7dd78dc' // Source: ../plugins/cookieinformation (mode: 'client')
import nuxt_plugin_gtmloader_07ad6ce1 from 'nuxt_plugin_gtmloader_07ad6ce1' // Source: ../plugins/gtm-loader.js (mode: 'client')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../plugins/gtm (mode: 'client')
import nuxt_plugin_activeCampaign_2b6559a8 from 'nuxt_plugin_activeCampaign_2b6559a8' // Source: ../plugins/activeCampaign (mode: 'client')
import nuxt_plugin_linkedin_3a4cd674 from 'nuxt_plugin_linkedin_3a4cd674' // Source: ../plugins/linkedin (mode: 'client')
import nuxt_plugin_checkAuth_f0ea47cc from 'nuxt_plugin_checkAuth_f0ea47cc' // Source: ../plugins/checkAuth (mode: 'client')
import nuxt_plugin_engagement_2d181835 from 'nuxt_plugin_engagement_2d181835' // Source: ../plugins/engagement (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"The Hub | Find your next exciting startup job","htmlAttrs":{"lang":"en"},"meta":[{"hid":"charset","charset":"utf-8"},{"hid":"viewport","name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"x-ua","http-equiv":"X-UA-Compatible","content":"IE=edge"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"twitter:card","name":"twitter:card","content":"photo"},{"hid":"og:title","property":"og:title","content":"The Hub | Find your next exciting startup job"},{"hid":"twitter:title","name":"twitter:title","content":"The Hub | Find your next exciting startup job"},{"hid":"twitter:url","name":"twitter:url","content":"https:\u002F\u002Fhubtest.io"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fhubtest.io"},{"hid":"description","name":"description","content":"We connect global talents with career opportunities in Nordic startups. Search through thousands of startup jobs, across location and remote positions"},{"hid":"og:description","property":"og:description","content":"We connect global talents with career opportunities in Nordic startups. Search through thousands of startup jobs, across location and remote positions"},{"hid":"twitter:description","name":"twitter:description","content":"We connect global talents with career opportunities in Nordic startups. Search through thousands of startup jobs, across location and remote positions"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fhubtest.io\u002Fimages\u002Fthehub_2022.jpg"},{"hid":"twitter:image","property":"twitter:image","content":"https:\u002F\u002Fhubtest.io\u002Fimages\u002Fthehub_2022.jpg"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"\u002Fapple-touch-icon.png"},{"rel":"android-chrome","sizes":"192x192","href":"\u002Fandroid-chrome-192x192.png"},{"rel":"android-chrome","sizes":"512x512","href":"\u002Fandroid-chrome-512x512.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"32x32","href":"\u002Ffavicon-32x32.png"},{"rel":"icon","type":"image\u002Fpng","sizes":"16x16","href":"\u002Ffavicon-16x16.png"},{"rel":"preload","href":"\u002Ffonts\u002FVolkart-Regular.woff2","as":"font","type":"font\u002Fwoff2"},{"rel":"preload","href":"\u002Ffonts\u002FVolkart-Bold.woff2","as":"font","type":"font\u002Fwoff2"},{"hid":"link:canonical","rel":"canonical","href":"https:\u002F\u002Fhubtest.io"}],"script":[{"src":"https:\u002F\u002Fvouch.careers\u002Fembeded.js","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function (w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e].p&&e[e][p]()))?1:0})(window,'navigator','doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,l){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'})})(window,'dataLayer');window._gtm_inject=function(i){(function(d,s){var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f)})(document,'script');}}"}],"__dangerouslyDisableSanitizersByTagID":{"ldjson-schema":["innerHTML"],"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]},"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_15907473 === 'function') {
    await nuxt_plugin_bootstrapvue_15907473(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_36e2bbcc === 'function') {
    await nuxt_plugin_gtm_36e2bbcc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bugsnagclientbedf0236_e38eaa74 === 'function') {
    await nuxt_plugin_bugsnagclientbedf0236_e38eaa74(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_11ae9c28 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_11ae9c28(app.context, inject)
  }

  if (typeof nuxt_plugin_libmoduleplugin718bb2ca_ff181700 === 'function') {
    await nuxt_plugin_libmoduleplugin718bb2ca_ff181700(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5c841a44 === 'function') {
    await nuxt_plugin_axios_5c841a44(app.context, inject)
  }

  if (typeof nuxt_plugin_router_2f688c2a === 'function') {
    await nuxt_plugin_router_2f688c2a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_polyfills_7dce8c4e === 'function') {
    await nuxt_plugin_polyfills_7dce8c4e(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_3336a20a === 'function') {
    await nuxt_plugin_utils_3336a20a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_clientUtils_9395db20 === 'function') {
    await nuxt_plugin_clientUtils_9395db20(app.context, inject)
  }

  if (typeof nuxt_plugin_events_6a03e7e2 === 'function') {
    await nuxt_plugin_events_6a03e7e2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cookieinformation_a7dd78dc === 'function') {
    await nuxt_plugin_cookieinformation_a7dd78dc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtmloader_07ad6ce1 === 'function') {
    await nuxt_plugin_gtmloader_07ad6ce1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_activeCampaign_2b6559a8 === 'function') {
    await nuxt_plugin_activeCampaign_2b6559a8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_linkedin_3a4cd674 === 'function') {
    await nuxt_plugin_linkedin_3a4cd674(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_checkAuth_f0ea47cc === 'function') {
    await nuxt_plugin_checkAuth_f0ea47cc(app.context, inject)
  }

  if (typeof nuxt_plugin_engagement_2d181835 === 'function') {
    await nuxt_plugin_engagement_2d181835(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
